export default __webpack_public_path__ + "static/media/03_photo.6bc0c1c5.jpeg";